import { createReducer } from '@common/redux-utils';
import {
  ActioningActionType,
  SetActioningListAction,
  CompleteCommentAction,
  BeginLoadActionsAction
} from './actioning.actions';
import { CommentViewModel } from '@models/Comment';

export interface ActioningState {
  readonly actioningList: Array<CommentViewModel>;
  readonly pageNumber?: number;
  readonly pageSize?: number;
  readonly totalResults?: number;
  readonly pageCount?: number;
  readonly loading?: boolean;
}

export const initialActionState: ActioningState = {
  actioningList: []
};

function handleSetActioningList(state: ActioningState, action: SetActioningListAction): ActioningState {
  return {
    ...state,
    loading: false,
    actioningList: action.actioningList,
    pageNumber: action.pageNumber,
    pageSize: action.pageSize,
    totalResults: action.totalResults,
    pageCount: action.totalResults <= 0 ? 0 : Math.ceil(action.totalResults / action.pageSize)
  };
}

function handleSetCompleteComment(state: ActioningState, action: CompleteCommentAction): ActioningState {
  return {
    ...state
  };
}

function handleBeginLoadActions(state: ActioningState, action: BeginLoadActionsAction): ActioningState {
  return {
    ...state,
    loading: true
  };
}

export const ActioningReducer = createReducer<ActioningState, ActioningActionType>(initialActionState, {
  [ActioningActionType.SetActioningList]: handleSetActioningList,
  [ActioningActionType.CompleteComment]: handleSetCompleteComment,
  [ActioningActionType.BeginLoadActions]: handleBeginLoadActions
});



// WEBPACK FOOTER //
// ./src/actioning/actioning.reducer.ts